import {
  getPortalRole,
  getSelectedBusinessId,
} from '../app/businessContext';
import { buildWebSocketUrl } from './apiConfig';

export function subscribeToPurchaseOrderChanges(onChange) {
  if (typeof WebSocket === 'undefined') {
    return () => {};
  }

  let socket = null;
  let reconnectTimeoutId = null;
  let shouldReconnect = true;

  function connect() {
    const websocketUrl = new URL(buildWebSocketUrl('/ws'));
    const businessId = getSelectedBusinessId();
    const portalRole = getPortalRole();

    if (businessId) {
      websocketUrl.searchParams.set('businessId', businessId);
    }

    if (portalRole) {
      websocketUrl.searchParams.set('portalRole', portalRole);
    }

    socket = new WebSocket(websocketUrl.toString());

    socket.addEventListener('message', (event) => {
      const message = parseRealtimeMessage(event.data);

      if (message?.type === 'purchase-order-changed') {
        onChange(message.payload || {});
      }
    });

    socket.addEventListener('close', () => {
      if (!shouldReconnect) {
        return;
      }

      reconnectTimeoutId = window.setTimeout(connect, 2000);
    });
  }

  connect();

  return () => {
    shouldReconnect = false;

    if (reconnectTimeoutId) {
      window.clearTimeout(reconnectTimeoutId);
    }

    if (socket) {
      socket.close();
    }
  };
}

function parseRealtimeMessage(data) {
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
}
